import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Pointer = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="83" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.9364 45.6781L0.276886 31.7552L41.1518 15.4966L82.1975 0.416962L67.1169 41.4627L50.8593 82.3366L36.9364 45.6781Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
